export const metatagilistahoteli = {
  Page: {
    "meta-tagi": {
      Title: "Wyspy Kanaryjskie - lista hoteli",
      Description:
        "Wszystkie hotele z Wysp Kanaryjskich dostępne do rezerwacji. Sprawdź listę wszystkich hoteli. Lista Hoteli z Wysp Kanaryjskich – sprawdź gdzie i kiedy jechać! ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
